import script from "./PayRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayRecord.vue?vue&type=script&lang=ts&setup=true"

import "./PayRecord.vue?vue&type=style&index=0&id=25287f6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25287f6c"]])

export default __exports__